var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f9f9f9;\r\n        stroke: #ececec;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #d9d9d9;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(-304.933 -17.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_110",
    "data-name": "Rectangle 110",
    className: "cls-1",
    transform: "translate(304.933 17.625)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 41,
    height: 41,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 40,
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "addtofavourites",
    className: "cls-2",
    d: "M18.116,30a5.84,5.84,0,0,0-3.648,1.261,8.309,8.309,0,0,0-2.134,2.566A8.308,8.308,0,0,0,10.2,31.261,5.84,5.84,0,0,0,6.553,30C2.817,30,0,33.055,0,37.107c0,4.377,3.514,7.372,8.835,11.906.9.77,1.928,1.643,2.992,2.573a.771.771,0,0,0,1.015,0c1.064-.931,2.089-1.8,2.993-2.574,5.32-4.533,8.834-7.528,8.834-11.906C24.668,33.055,21.851,30,18.116,30Z",
    transform: "translate(313.62 -3.688)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.c578f982cf14aa0f01cb91c3a9341696.svg";
export { ForwardRef as ReactComponent };